import axios from "axios";
const BASE_URL = "https://praneeshinfotech.com/kongudevapi/api";

const getConfig = () => {
    const token = localStorage.getItem("token");
    return {
        headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
        },
    };
};

// Get membership plans
export const getSubscriptionPlans = () =>
    axios.get(`${BASE_URL}/membership-plans`, getConfig());

// Get member subscriptions and payment history
export const getMemberSubscriptions = (memberId) =>
    axios.get(
        `${BASE_URL}/subscriptions`,
        {
            ...getConfig(),
            params: { member_id: memberId },
        }
    );

// Create cash / UPI subscription
export const createMemberSubscription = (payload) =>
    axios.post(
        `${BASE_URL}/subscriptions`,
        payload,
        getConfig()
    );

// Verify pending payment
export const verifySubscriptionPayment = (subscriptionId, payload) =>
    axios.patch(
        `${BASE_URL}/subscriptions/${subscriptionId}/verify-payment`,
        payload,
        getConfig()
    );